export default "__VITE_ASSET__CGjxt_4e__"